import * as React from 'react';

import { PageTitleBar } from 'components';

const PaymentGatewayHeader = ({
  children,
}: React.PropsWithChildren<unknown>) => <PageTitleBar headerTitle={children} />;

export { PaymentGatewayHeader };
